import { computeDelta, convertDateToTimezone, extractToLocal, roundedToTheHalf } from '@app/booking-libs';
import { useReducer } from 'react';
import { useUserContext } from '../libs/useUserContext';
export const DurationCompute = ['days', 'hours', 'minutes'];
function addDurationTo(date, duration) {
    const result = new Date(date);
    const { days, hours, minutes } = duration;
    result.setDate(result.getDate() + days);
    result.setHours(result.getHours() + hours);
    result.setMinutes(result.getMinutes() + minutes);
    return extractToLocal(result);
}
export function reducer(state, action) {
    switch (action.type) {
        case 'update-resource':
            return {
                ...state,
                resource: action.payload.resource
            };
        case 'update-summary':
            return {
                ...state,
                summary: action.payload.value
            };
        case 'update-start': {
            const a = action;
            const { startDate } = a.payload;
            const endDate = addDurationTo(startDate, state.duration);
            return {
                ...state,
                startDate: startDate,
                endDate: endDate
            };
        }
        case 'update-end': {
            const a = action;
            const { endDate } = a.payload;
            const duration = computeDelta(new Date(state.startDate).getTime(), new Date(endDate).getTime(), DurationCompute);
            return {
                ...state,
                duration,
                endDate
            };
        }
        case 'update-duration': {
            const a = action;
            const { days, hours, minutes } = a.payload;
            const end = new Date(state.startDate);
            end.setDate(end.getDate() + days);
            end.setHours(end.getHours() + hours);
            end.setMinutes(end.getMinutes() + minutes);
            return {
                ...state,
                duration: a.payload,
                endDate: extractToLocal(end)
            };
        }
    }
}
const now = new Date();
const later = new Date();
later.setDate(later.getDate() + 1);
const nowISO = roundedToTheHalf(now).toISOString();
const laterISO = roundedToTheHalf(later).toISOString();
export function useBookingForm(defaultState) {
    const user = useUserContext();
    const initialStartDate = extractToLocal(convertDateToTimezone(nowISO, user.timezone));
    const initialEndDate = extractToLocal(convertDateToTimezone(laterISO, user.timezone));
    const startDate = defaultState.startDate || initialStartDate;
    const endDate = defaultState.endDate || initialEndDate;
    const summary = defaultState.summary || '';
    const duration = computeDelta(new Date(startDate).getTime(), new Date(endDate).getTime(), DurationCompute);
    const finalDefaultState = {
        ...defaultState,
        startDate,
        endDate,
        duration,
        summary
    };
    const [state, dispatch] = useReducer(reducer, finalDefaultState);
    return {
        state,
        dispatch
    };
}
